var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66667 19.0485C4.19818 20.1374 2.66667 21.6549 2.66667 23.3333C2.66667 26.647 8.6362 29.3333 16 29.3333C23.3638 29.3333 29.3333 26.647 29.3333 23.3333C29.3333 21.6549 27.8018 20.1374 25.3333 19.0485M24 10.6667C24 16.0849 18 18.6667 16 22.6667C14 18.6667 8 16.0849 8 10.6667C8 6.24839 11.5817 2.66666 16 2.66666C20.4183 2.66666 24 6.24839 24 10.6667ZM17.3333 10.6667C17.3333 11.403 16.7364 12 16 12C15.2636 12 14.6667 11.403 14.6667 10.6667C14.6667 9.93028 15.2636 9.33333 16 9.33333C16.7364 9.33333 17.3333 9.93028 17.3333 10.6667Z",
    stroke: "#6AD67D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.74bd09c55fb051bae2c273f221b0af7b.svg";
export { ForwardRef as ReactComponent };